import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mains" }
const _hoisted_2 = { class: "be-info" }
const _hoisted_3 = { class: "van-cell__value info-value" }
const _hoisted_4 = { class: "van-cell__value info-value" }
const _hoisted_5 = { class: "van-cell__value info-value" }
const _hoisted_6 = { class: "van-cell__value info-value" }
const _hoisted_7 = { style: {"text-align":"right"} }
const _hoisted_8 = { style: {"text-align":"center","margin":"39px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_calendar = _resolveComponent("van-calendar")!
  const _component_LicensePlate = _resolveComponent("LicensePlate")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      "scroll-to-error": true,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_cell, {
            "is-link": "",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => _ctx.info.showorg(), ["stop"]))
          }, {
            title: _withCtx(() => [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 被访单位 ")
              ], -1)),
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_van_field, {
                  placeholder: "请选择被访单位",
                  readonly: "",
                  clickable: "",
                  modelValue: _ctx.info.form.beAccessOrgName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.info.form.beAccessOrgName) = $event)),
                  rules: [
                  {
                    required: true,
                    message: '请选择'
                  }
                ]
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_popup, {
            show: _ctx.info.InterUnitShow,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.info.InterUnitShow) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                clickable: "",
                modelValue: _ctx.info.keyvalue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.info.keyvalue) = $event)),
                "left-icon": "search",
                placeholder: "搜索被访单位",
                style: {"height":"40px","padding":"10px"}
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_picker, {
                columns: _ctx.info.InterUnitss,
                onConfirm: _ctx.info.InterUnitConfirm,
                onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.info.InterUnitShow = false))
              }, null, 8, ["columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_van_cell, {
            "is-link": "",
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => (_ctx.info.InterXQ = true), ["stop"]))
          }, {
            title: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 到访校区 ")
              ], -1)),
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_van_field, {
                  placeholder: "请选择到访校区",
                  readonly: "",
                  clickable: "",
                  modelValue: _ctx.info.form.visiCampus,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.info.form.visiCampus) = $event)),
                  rules: [
                  {
                    required: true,
                    message: '请选择'
                  }
                ]
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_action_sheet, {
            show: _ctx.info.InterXQ,
            "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.info.InterXQ) = $event)),
            actions: _ctx.info.InterXQs,
            "cancel-text": "取消",
            "close-on-click-action": "",
            onSelect: _ctx.info.interXQSelect
          }, null, 8, ["show", "actions", "onSelect"]),
          _createVNode(_component_van_cell, {
            "is-link": "",
            onClick: _cache[9] || (_cache[9] = _withModifiers(() => (_ctx.info.calendarShow = true), ["stop"]))
          }, {
            title: _withCtx(() => [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 到访日期 ")
              ], -1)),
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_van_field, {
                  placeholder: "请选择到访日期",
                  readonly: "",
                  clickable: "",
                  modelValue: _ctx.info.form.visiStartTime,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.info.form.visiStartTime) = $event)),
                  rules: [
                  {
                    required: true,
                    message: '请选择'
                  }
                ]
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_calendar, {
            show: _ctx.info.calendarShow,
            "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.info.calendarShow) = $event)),
            onConfirm: _ctx.info.calendarConfirm
          }, null, 8, ["show", "onConfirm"]),
          _createVNode(_component_van_cell, null, {
            title: _withCtx(() => [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 来访事由 ")
              ], -1)),
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_van_field, {
                  placeholder: "请填写来访事由",
                  modelValue: _ctx.info.form.reason,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.info.form.reason) = $event)),
                  rows: "2",
                  autosize: "",
                  type: "textarea",
                  maxlength: "300",
                  "show-word-limit": "",
                  rules: [
                  {
                    required: true,
                    message: '请填写'
                  }
                ]
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "title" }, "到访车辆", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.form.carsRecordList, (car, i) => {
          return (_openBlock(), _createBlock(_component_van_cell_group, {
            key: i,
            inset: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: car.plateNum,
                "onUpdate:modelValue": ($event: any) => ((car.plateNum) = $event),
                required: "",
                readonly: "",
                label: "车牌号",
                rules: [
            {
              required: true,
              message: '请填写'
            },
            {
              pattern: /^.{7,8}$/,
              message: '请填写正确的车牌号'
            }
          ],
                placeholder: "请输入车牌号"
              }, {
                input: _withCtx(() => [...(_cache[16] || (_cache[16] = []))]),
                extra: _withCtx(() => [
                  _createVNode(_component_LicensePlate, {
                    modelValue: car.plateNum,
                    "onUpdate:modelValue": ($event: any) => ((car.plateNum) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: car.visitorName,
                "onUpdate:modelValue": ($event: any) => ((car.visitorName) = $event),
                required: "",
                label: "车主姓名",
                rules: [
            {
              required: true,
              message: '请填写'
            }
          ],
                placeholder: "请输入车主姓名"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: car.visitorPhone,
                "onUpdate:modelValue": ($event: any) => ((car.visitorPhone) = $event),
                required: "",
                label: "联系电话",
                type: "tel",
                placeholder: "请输入联系电话",
                rules: [
            {
              required: true,
              message: '请填写'
            },
            {
              pattern: /^1\d{10}$|^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/,
              message: '电话号码格式不正确'
            }
          ]
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _withDirectives(_createVNode(_component_van_icon, {
                class: "del-car",
                name: "delete-o",
                onClick: _withModifiers(($event: any) => (_ctx.info.delACar(i)), ["stop"]),
                color: "#ee0a24",
                size: "23px"
              }, null, 8, ["onClick"]), [
                [_vShow, i != 0]
              ])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_button, {
            plain: "",
            hairline: "",
            type: "primary",
            icon: "plus",
            size: "small",
            onClick: _ctx.info.addACar
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("点击添加车辆", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ], 512), [
          [_vShow, _ctx.info.form.carsRecordList.length < 5]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_van_button, {
            class: "submit-btn",
            color: "#1989fa",
            loading: _ctx.info.submit_loading,
            "loading-text": "提交中...",
            onClick: _ctx.info.submit
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("提交审批", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}